export type TourStep = {
  selector: string;
  title: string;
  content: string;
  backgroundImage: string;
  cta: {
    text: string;
    url: string;
  };
  media: {
    type: MediaTypeEnum;
    source: string;
  };
};

export type ProductTour = {
  id: string;
  steps: TourStep[];
  moduleIds: string[];
  tourId: string;
};
 
export enum MediaTypeEnum {
  Video = "video",
  Image = "image",
}
